// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8a8c22f8","455":"b28ccdc0","977":"ebeb5dfb"}[chunkId] + ".chunk.js";
};